import { render, staticRenderFns } from "./CvSummary.vue?vue&type=template&id=2d1c1a09&scoped=true"
import script from "./CvSummary.vue?vue&type=script&lang=js"
export * from "./CvSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c1a09",
  null
  
)

export default component.exports